import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { PermissionService } from '../../../core/services/permission.service';
import { NAV_ITEMS } from '../nav-items';

// Reemplaza el `mobileNav.innerHTML` de _nav.js (`NAV_ITEMS.slice(0, 5)`, fijo sin
// permisos). Acá se filtra primero por permiso (igual que SidebarComponent) y luego se
// toman los primeros 5 — mismo criterio, sin duplicar la lista.
@Component({
  selector: 'app-bottom-nav',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './bottom-nav.component.html',
})
export class BottomNavComponent {
  private readonly permissionService = inject(PermissionService);

  readonly navItems = computed(() =>
    NAV_ITEMS.filter((item) => !item.permission || this.permissionService.hasPermission(item.permission)).slice(0, 5),
  );
}
